import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      q: 'Are Bernard Fan Co. fans only decorative OR functional as well?',
      a: 'Bernard Fan Co. fans are both aesthetic as well as functional. Our fans displace between 4000 and 16000 CFM of air and rotate between 100 and 840 RPM with a blade angle the displaces 3X volume of air more consistently when compared to conventional fans thereby allowing you to experience superior air flow.'
    },
    {
      q: 'Why are Bernard Fan Co. fans more expensive than conventional fans?',
      a: 'Our fans are aesthetically appealing, functionally superior and made of finest quality and craftsmanship. They are made to not only give you a luxurious breeze experience, but also beautify your home by adding elements of grace, elegance & grandeur; all while being Eco-friendly and Whisper Quiet.\n\nOther than the above, these are made in China and hold the highest finishing and quality standards.'
    },
    {
      q: 'How long do these fans last?',
      a: 'More than 20 years'
    },
    {
      q: 'How do I decide what fan to purchase?',
      a: '1. **By its look**: We have an extensive range of models to suit every part of your home. Each model contributes to your design aesthetic in some way or the other.\n\n2. **By the Specific use case**: We have fans specially for dining tables, walk-in closets, corporate offices, hospitality, living rooms, bedrooms, double height ceilings, balconies and more.\n\n3. **By the functionality**: For example; fans with Natural Breeze Feature or Summer-Winter feature.\n\n4. **By the size**: Oversized fans for larger spaces/ double height ceiling fans/ multi purpose fans and more.'
    },
    {
      q: 'What about installation?',
      a: 'All our fans are made for Pakistani conditions, any electrician can install a Bernard Fan co. fan. Our fans are integrated on the Hook- and - bush mechanism - like any conventional Pakistani fan.\n\nAll our fans come with installation manuals and we also provide expert assist to any electrician over the phone or a Whatsapp video.'
    },
    {
      q: 'How much power does a Bernard Fan Co. fan consume/absorb?',
      a: 'All our fans are Eco-friendly and have a low rate of power consumption. Our fans come with brushless DC motors (BL-DC) which consume 8 to 35 watts of power. Conventional fans require 80 to 95 W for a 3-blade fan. Our fans also come with LEDs which increases the efficiency of your space.'
    },
    {
      q: 'Can we adjust the length/height of a fan (for higher/lower cielings)?',
      a: 'Yes! We can adjust the size of the rods as desired. We can go as low as a 8ft height (from floor to ceiling), or as high as 25ft (from floor to ceiling).'
    },
    {
      q: 'Can the fans be installed for double height ceilings?',
      a: 'Yes, our fans can be installed for double height ceilings with custom made rods. The fans do not wobble and give you continuous refreshing breeze.'
    },
    {
      q: 'What is the minimum height required to install a wall mount fan?',
      a: 'While there is no minimum height requirement to install a wall mounted fan, we do recommend you do it at a minimum of 8ft to avoid anyone walking into it.'
    },
    {
      q: 'Can the wall mount fans be installed in the ceiling?',
      a: 'Yes, our multi-purpose fans have the option to be installed as ceiling mount fans.'
    },
    {
      q: 'I have a false ceiling, can I still install these fans?',
      a: 'Yes! You can.'
    },
    {
      q: 'What if my false ceiling is already closed up?',
      a: 'You make a small 4-inch hole in the false ceiling to fix our rod and then no further work is required as the canopy of the fan covers the hole altogether.'
    },
    {
      q: 'What are the different blade materials available?',
      a: 'We have a wide range of options to suit your interiors. The different options of blade materials include; Natural Wooden blades, ABS blades, Aluminium blades and Plywood blades.'
    },
    {
      q: 'How do I maintain the fans?',
      a: '1. Dry cloth once a week.\n\n2. Wet cloth once a month.'
    },
    {
      q: 'Warranty?',
      a: '1. One year manufacturing warranty with parts.\n\n2. Lifetime service warranty.'
    },
    {
      q: 'Does Bernard Fan Co. carry spare parts?',
      a: 'Yes! We are always equipped with spare parts.'
    },
    {
      q: 'How is the speed compared to conventional fans?',
      a: 'The breeze or air displacement of a fan is calculated in CFM or cubic feet per minute. CFM is a function of the following:\n\n1. Blade size: Our blades are on average longer than those of conventional fans covering a larger area.\n\n2. Effective blade pitch: Our fans are minimum 3X in terms of blade angle and displace more air.\n\n3. RPM: Our fans rotate between 100 RPM and 840 RPM.\n\nBy achieving the right mix of these three we have managed to give you a higher yet luxurious breeze experience. While being Eco-friendly and being whisper quiet.'
    },
    {
      q: 'What is the sweep of a Bernard Fan Co. fan?',
      a: 'Our fans vary from 16 inches to 78 inches in blade sweep or diameter. The higher the sweep the larger the area it covers.'
    },
    {
      q: 'What is the Reversible Blade feature?',
      a: 'The reversible blade feature is one wherein the blades have one finish/colour on one side and a different finish/colour on the other. So you may have a different looking fan when the blades are reversed.'
    },
    {
      q: 'What is the Summer-Winter feature? Also known as bi-directional rotation/reversed airflow feature.',
      a: 'The Summer-Winter feature allows the fan to rotate both anti-clockwise as well as clockwise. The former allows the fan to give you a cool breeze (for the warmer climate) while the latter gives you a cosy, warm air effect (for the cooler climate).\n\nUsually fans rotate anti clockwise to give you a breeze. There are times when its cold outside or you are not feeling well, or in a couple - when one wants the fan and the other doesn\'t - you may turn the rotation of the fan in the clockwise direction - which behaves as an exhaust and vacuums the air above, thereby giving you circulation rather than a breeze. This is also handy over a dining table.'
    },
    {
      q: 'What is the Natural Breeze feature?',
      a: 'The Natural Breeze feature is designed to ensure that the user never has toggle the controls of the fan to get just the right breeze at various times in one night. This mode alternates between higher and lower speeds, ensuring an even flow of air and a comfortable breeze all through the day and night.'
    },
    {
      q: 'Do you have energy efficient BL-DC motor (Brushless DC motor) fans?',
      a: 'Bernard Fan Co. has always been at the forefront of innovation. Our Brushless DC motor fans consume around 8 to 34 watts of power. The power consumption is reduced by around 70% and hence the BLDC motor fans are energy efficient, whisper quiet and remote operated.'
    },
    {
      q: 'Do the fans make any noise?',
      a: 'All our fans are completely Whisper Quiet. Under 40 Db - 54 Db.'
    },
    {
      q: 'How do I reach out to support team at Bernard Fan Co.?',
      a: 'You can reach out to us at +923072222302'
    },
    {
      q: 'How good is Bernard Fan Co. service?',
      a: 'Some of our customers say that we are the best brand they have worked with in terms of process and service. All our technicians are certified hence we will always do our best to make sure your product and experience is at its best.'
    },
    {
      q: 'What happens if my fan is shaky or wobbly?',
      a: 'Contact us, we\'ll take care of it!'
    },
    {
      q: 'Our kids bedroom has bunk beds, is there any option other than ceiling fans?',
      a: 'Our Blade-less ceiling fan is perfect if you have lower height ceilings or if you do not want the blades of the fans to be exposed. Alternatively you can also go with a wall mount option which is compact at provides you with a refreshing breeze.'
    },
    {
      q: 'What happens if my remote stops working?',
      a: 'In case you face an issue with your remote, we recommend you do the following:-\n\n1. Change the battery of the remote.\n\n2. In case the remote still does not work, you can reach out to our support team. We will be happy to resolve the issue for you.'
    },
    {
      q: 'My Bernard Fan Co. fan is giving me less air. What do I do?',
      a: '1. Check if your regulator is on full. The regulation is done by the remote receiver.\n\n2. Check what direction your fan is oscillating. If its in the clockwise direction, you will have to change the direction of oscillation to anti clockwise. You may do this from the remote control.\n\n3. Check your current fluctuation is your household.'
    },
    {
      q: 'What is the ideal distance of the fan blade from the ceiling for optimal breeze?',
      a: '10 to 12 inches.'
    },
    {
      q: 'Is the fan speed variable?',
      a: 'Yes. We have a minimum of 3 and a maximum of 6 different speed variations. For further information, please refer to the specification of each fan.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/images/faqs-background.jpeg)' }}
        ></div>
        
        {/* Minimal overlay for text readability */}
        <div className="absolute inset-0 bg-stone-900/30"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-light tracking-tight text-white mb-6 drop-shadow-lg">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto font-light leading-relaxed drop-shadow-md">
            Everything you need to know about Bernard Fan Co. and our luxury fan collections
          </p>
        </div>
      </section>

      {/* FAQ Sections */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-stone-200 px-6"
              >
                <AccordionTrigger className="text-left text-lg font-light text-stone-900 hover:text-stone-700 py-6">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone-600 leading-relaxed pb-6">
                  {faq.a.split(/(\*\*.*?\*\*)/).map((part, i) => {
                    if (part.startsWith('**') && part.endsWith('**')) {
                      return <strong key={i}>{part.slice(2, -2)}</strong>;
                    }
                    return <span key={i} className="whitespace-pre-line">{part}</span>;
                  })}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-20 bg-stone-100">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-light tracking-tight text-stone-900 mb-6">
            Still Have Questions?
          </h2>
          <p className="text-lg text-stone-600 leading-relaxed mb-8">
            Our team is here to help. Reach out for personalized assistance with your inquiry.
          </p>
          <button
            onClick={() => window.location.href = '/display-centres'}
            className="bg-stone-900 hover:bg-stone-800 text-stone-50 px-10 py-4 text-sm tracking-widest transition-all duration-300"
          >
            VISIT DISPLAY CENTRES
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};